<template>
    <div class="recurrent-store-order-page">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors && order">
            <div class="row mb-4 align-items-center">
                <div class="col-md-6 col-12">
                    <PreparationCustomerOrderCustomerInformation
                        :order="order"
                    />
                </div>
                <div class="col-md-6 col-12">
                    <div class="float-right">
                        <button @click="$refs.modalCustomerInformation.showModal()" class="btn lcdd-btn-with-icon btn-outline-dark mx-2">
                            <div class="lcdd-btn-icon">
                                <i class="fad fa-file-user fa-2x"></i>
                            </div>
                            Infos<br />commande
                        </button>

                        <div class="dropdown d-inline-block">
                            <button class="btn lcdd-btn-with-icon btn-outline-dark btn-md dropdown-toggle ml-2" type="button" id="orderDropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div class="lcdd-btn-icon">
                                    <i class="fad fa-list fa-2x"></i>
                                </div>
                                Autres<br />actions
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="orderDropdownMenuButton">
                                <a class="dropdown-item"
                                   :href="'/espace-employes/commandes/commande-magasin-recurrente/' + this.order.id + '/edition'">
                                    <i class="fad fa-user-lock"></i> Modifier la commande
                                </a>

                                <button class="dropdown-item"
                                        @click="$refs.modalCancelRecurrentOrder.showModal()">
                                    <i class="fad fa-trash"></i> Supprimer cette commande récurrente
                                </button>

                                <button v-if="order && order.id" class="dropdown-item" @click="$refs.modalOrderHistory.showModal()">
                                    <i class="fad fa-clock"></i> Voir l'historique
                                </button>
                            </div>
                        </div>

                        <CustomerInformationModal
                            ref="modalCustomerInformation"
                            :order="order"
                        />

                        <OrderHistoryModal
                            ref="modalOrderHistory"
                            :order="order"
                        />

                        <CancelRecurrentOrderModal
                            ref="modalCancelRecurrentOrder"
                            :order="order"
                        />
                    </div>
                </div>
            </div>

            <template v-for="categoryAndProducts in productsByMainCategory">
                <div class="row mt-4">
                    <div class="col-md-12">
                        <h3>{{ categoryAndProducts.category.name }}</h3>
                    </div>
                </div>

                <div class="row">
                    <OrderedProduct
                        v-for="(entry, sku) in categoryAndProducts.products"
                        class="col-md-3 ml-2"
                        :key="sku"
                        :order="order"
                        :sku="entry.product.sku"
                        :name="entry.product.tiny_name"
                        :nb-ordered="entry.nb_ordered"
                    />
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import CancelRecurrentOrderModal from "../CancelRecurrentOrderModal"
    import CustomerInformationModal from "../Preparation/CustomerOrder/CustomerInformationModal";
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";
    import OrderHistoryModal from "../OrderHistoryModal"
    import OrderPreparationMenu from "../Preparation/OrderPreparationMenu";
    import OrderedProduct from "./OrderedProduct"
    import PreparationCustomerOrderCustomerInformation from "../Preparation/PreparationCustomerOrderCustomerInformation"

    import {useGetLoader} from "../compositions/axios/loadingRequest";

    export default {
        name: 'RecurrentStoreOrderPage',

        components: {
            CancelRecurrentOrderModal,
            CustomerInformationModal,
            ErrorsZone,
            LoadingScreen,
            OrderHistoryModal,
            OrderPreparationMenu,
            OrderedProduct,
            PreparationCustomerOrderCustomerInformation,
        },

        props: {
            orderId: {
                type: String,
                required: true,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                order: null,
                productsByMainCategory: [],
                loadedOnce: false,
            }
        },

        async mounted() {
            await this.loadStateFromServer();
        },

        methods: {
            async loadStateFromServer() {
                const data = await this.load(`/espace-employes/commandes/commande-magasin-recurrente/${this.orderId}/json`);
                if (data) {
                    this.order = data.order;
                    this.productsByMainCategory = data.productsByMainCategory;
                    this.loadedOnce = true;
                }
            },
        },
    }
</script>
